import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: 'f5d6e19b948e994be252c3a2acc59483',
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.VERSION,
  releaseStage: process.env.RELEASE,
  notifyReleaseStages: ['production'],
});

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue);
